<template>
  <div id="team">
    <Navbar />

    <b-carousel
      id="carousel"
      fade
      :interval="4000"
    >
      <b-carousel-slide
        v-for="(slide, i) in $store.state.slides"
        v-bind:key="i"
        class="c-img"
        :style="'background: url(' + slide + ') no-repeat center center fixed;background-size: cover;'"
      ></b-carousel-slide>
    </b-carousel>

    <div class="underlay"></div>

    <div class="container">
      <h1 class="mb-4">Frizlen Team</h1>

      <div class="row">
        <div
          v-for="(teamMember, i) in team"
          v-bind:key="i"
          class="col-md-4"
        >
          <div
            class="card clickable"
            :class="{highlight:i == hovered}"
            @mouseover="hovered = i"
            @mouseleave="hovered = null"
            @click="viewBio(teamMember)"
          >
            <img :src="teamMember.image" class="card-img-top" />
            <div class="card-body">
              <p class="card-text">
                <p class="lead mb-0">{{ teamMember.full_name }}</br><small>{{ teamMember.title }}</small></p>
                <small><i class="fas fa-phone"></i> {{ teamMember.phone }}<br>
                <i class="fas fa-envelope"></i> {{ teamMember.email }}</small>
              </p>
            </div><!-- /.card-body -->
          </div><!-- ./card -->
        </div><!-- /.col-md-3 -->
      </div><!-- /.row -->

      <!-- /.CARDS -->
      <!-- <b-card-group columns>
        <b-card
          v-for="(teamMember, i) in team"
          v-bind:key="i"
          :img-src="teamMember.image"
          img-alt="teamMember.full_name"
          img-top
          class="clickable"
          :class="{highlight:i == hovered}"
          @mouseover="hovered = i"
          @mouseleave="hovered = null"
          @click="viewBio(teamMember)"
        >
          <b-card-text>
            <p class="lead mb-0">{{ teamMember.full_name }}</br><small>{{ teamMember.title }}</small></p>
            <small><i class="fas fa-phone"></i> {{ teamMember.phone }}<br>
            <i class="fas fa-envelope"></i> {{ teamMember.email }}</small>
          </b-card-text>
        </b-card>
      </b-card-group> -->
    </div><!-- /.container -->

    <transition name="fade">
      <div
        v-if="loading == true"
        class="spinner d-flex justify-content-center mb-3"
      >
        <b-spinner style="width: 5rem; height: 5rem;" label="Loading..."></b-spinner>
      </div>
    </transition>

    <div v-if="showBio" class="o-modal">
      <div class="o-modal-content">
        <div class="o-modal-header">
          <a
            @click="showBio = false"
            class="close clickable"
          ><i class="fas fa-times"></i></a>
          <p class="lead">Bio</p>
        </div><!-- /.o-modal-header -->
        <div class="o-modal-body">
          <h2>{{ person.full_name }}</h2>
          <div v-html="person.bio" />
        </div><!-- /.o-modal-body -->
      </div><!-- /.o-modal-content -->
    </div><!-- /.o-modal -->

  </div>
</template>

<script>
import Navbar from './Navbar'
import axios from 'axios'

export default {
  data() {
    return {
      loading: true,
      team: [],
      hovered: null,
      person: {},
      showBio: false
    }
  },
  components: {
    Navbar
  },
  created() {
    this.getTeam()
  },
  methods: {
    viewBio (member) {
      this.person = member
      this.showBio = true
    },
    getTeam () {
      this.loading = true
      let timeStamp = new Date().getTime()
      let url = 'https://buffalofts.com/api/team?&timestamp=' + timeStamp
      axios.get(url).then(response => {
        this.team = response.data
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
#team {
  /* background: url(/static/backgrounds/portfolio.jpg) no-repeat center center fixed; */
  background-size: cover;
  padding-top: 100px;
  min-height: 100vh;
  position: relative;
}

#team .container {
  position: relative;
  z-index: 3;
}

#carousel {
  max-height: 100vh;
  overflow:hidden;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
/* #carousel {
  max-height: 100vh;
  overflow:hidden;
  height: 100vh;
} */
.c-img {
  height: 100vh;
}

/* ONLY ON LARGE SCREENS */
@media(min-width:600px) {
  .card {
    transition: all 0.2s ease-in-out;
    transform: scale(0.95);
  }
  .card:hover {
    box-shadow: 2px 3px 8px rgba(255,255,255,0.3);
    transform: scale(1);
  }

  .card img {
    transition: all 0.5s ease-in-out;
    filter: grayscale(0.85);
  }
  .highlight img {
    filter: grayscale(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Team.vue